module.exports = __webpack_public_path__ + "static/media/jokers-jewels.a786b159.gif";